import React from "react";
import "./App.css";
import * as microsoftTeams from "@microsoft/teams-js";
import { Trans, WithTranslation, withTranslation } from "react-i18next";

export const SetupInstructions = withTranslation()(class extends React.Component<WithTranslation> {
    render() { 
        const apiPort = 45455;
        
        return <Trans i18nKey="setupInstructions">
            <p>
                In order to work, you must have TeamDrive running on your PC, with API access enabled on
                port {{port: apiPort}}. This can be configured as follows:
            </p>
            <ol>
                <li>
                    If you do not have TeamDrive yet:
                    <ul>
                        <li>Download TeamDrive <a href="https://teamdrive.com/download" target="_new">here</a></li>
                        <li>Start TeamDrive and follow the instructions to register an account</li>
                    </ul>
                </li>
                <li>Close TeamDrive</li>
                <li>
                    Open the TeamDrive-Settings file:
                    <ul>
                        <li>On <b>Windows</b>, use notepad to open <pre>{{windowsPath: '%APPDATA%\\TeamDrive3\\teamdrive.settings'}}</pre></li>
                        <li>On <b>Mac</b>, use TextEdit to open <pre>{{macPath: '~/.teamdrive/teamdrive.settings'}}</pre></li>
                    </ul>
                </li>
                <li>On a new line at the end of the file enter <pre>http-api-port={{port: apiPort}}</pre></li>
                <li>Save and close the file</li>
                <li>Start TeamDrive again</li>
            </ol>
        </Trans>}
});

/**
 * The 'Config' component is used to display your group tabs
 * user configuration options.  Here you will allow the user to
 * make their choices and once they are done you will need to validate
 * their choices and communicate that to Teams to enable the save button.
 */
const TabConfig = withTranslation()(class extends React.Component<WithTranslation> {
    private infoUrl = "https://teamdrive.com/faq";

    render() {

        const t = this.props.t;

        // Initialize the Microsoft Teams SDK
        microsoftTeams.app.initialize().then(() => {
            /**
             * When the user clicks "Save", save the url for your configured tab.
             * This allows for the addition of query string parameters based on
             * the settings selected by the user.
             */
            microsoftTeams.pages.config.registerOnSaveHandler((saveEvent) => {
                const baseUrl = `https://${window.location.hostname}:${window.location.port}`;
                microsoftTeams.pages.config.setConfig({
                    suggestedDisplayName: "TeamDrive Files",
                    entityId: "TeamDriveFilesTab",
                    contentUrl: baseUrl + "/index.html#/files",
                    websiteUrl: baseUrl + "/index.html#/files",
                }).then(() => {
                    saveEvent.notifySuccess();
                });
            });

            /**
             * After verifying that the settings for your tab are correctly
             * filled in by the user you need to set the state of the dialog
             * to be valid.  This will enable the save button in the configuration
             * dialog.
             */
            microsoftTeams.pages.config.setValidityState(true);
        });

        return <div>
            <h3>{t('Welcome to the TeamDrive integration for Microsoft Teams')}</h3>
            <SetupInstructions></SetupInstructions>
        </div>;
    }
});

export default TabConfig;
